<template>
    <div class="top-value" v-if="showTopValue">
      <hp5-icon name="brand-trophy-2" size="lg"></hp5-icon>
      <div class="top-value-content">
        <hp5-heading class="top-value-heading" tag-selection="h3" size-selection="md">Top Value</hp5-heading>
        <hp5-link-text-tertiary target="_blank" href="top-value-learn-more" :data-card-rank="rank" text="How we award top value"></hp5-link-text-tertiary>
        <hp5-spacing-vertical xs="sm"></hp5-spacing-vertical>
      </div>
    </div>
</template>
  
<script setup>

    const props = defineProps({
        location: Object,
        rank: Number
    })

    const showTopValue = computed(() => {
      return props.location.betterChoiceCategory && props.location.betterChoiceCategory == 'HVN'
    })

</script>
  
<style scoped lang="scss">
  .top-value {
    display: flex;
    margin-bottom: var(--spacing-sm);
  
    .top-value-content {
      margin-left: var(--spacing-xxs);
      align-self: center;
    }
  }</style>